/*
 * @Author: 肖玲
 * @Date: 2023-05-15 10:36:13
 * @LastEditTime: 2023-06-02 19:16:43
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\cost-control\cost-policy-management\modules\policyFilingMaintenance.js
 * 政策备案维护
 */
import { getNavigationt } from '@/api/common'
const policyFilingMaintenanceRouter = [
  // 费控系统 费用政策管理  政策备案维护    产品价格政策
  {
    path: '/costControlSystem/policyFilingMaintenance/productPricePolicy/page',
    name: 'productPricePolicy',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/cost-policy-management/policy-filing-maintenance/product-price-policy/page.vue'
      ),
    meta: {
      SecondaryMenu: '政策备案维护', //二级菜单
      title: '产品价格政策',
      breadcrumb: [],
    },
  },
  // 费控系统 费用政策管理  政策备案维护    产品价格政策  新增政策
  {
    path: '/costControlSystem/policyFilingMaintenance/productPricePolicy/add/:cost_goods_policy_id',
    name: 'productPricePolicyAdd',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/cost-policy-management/policy-filing-maintenance/product-price-policy/Add.vue'
      ),
    meta: {
      SecondaryMenu: '政策备案维护', //二级菜单
      title: '新增产品价格政策',
      breadcrumb: [
        {
          title: '产品价格政策',
          name: 'productPricePolicy',
        },
      ],
    },
  },
  // 费控系统 费用政策管理  政策备案维护    产品价格政策  批量设置
  {
    path: '/costControlSystem/policyFilingMaintenance/productPricePolicy/batchSet/:goodsList/:regionList',
    name: 'productPricePolicyBatchSet',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/cost-policy-management/policy-filing-maintenance/product-price-policy/BatchSet.vue'
      ),
    meta: {
      SecondaryMenu: '政策备案维护', //二级菜单
      title: '批量设置产品价格政策',
      breadcrumb: [
        {
          title: '产品价格政策',
          name: 'productPricePolicy',
        },
      ],
    },
  },
  // 费控系统 费用政策管理  政策备案维护    高开税率政策
  {
    path: '/costControlSystem/policyFilingMaintenance/highTaxRatePolicy/page/:id',
    name: 'highTaxRatePolicy',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/cost-policy-management/high-tax-rate-policy/Page.vue'
      ),
    meta: {
      SecondaryMenu: '政策备案维护', //二级菜单
      title: '',
      breadcrumb: [],
    },
  },
  // 费控系统 费用政策管理  政策备案维护    高开税率政策  批量设置
  {
    path: '/costControlSystem/policyFilingMaintenance/highTaxRatePolicy/batchSet/:id',
    name: 'highTaxRatePolicyBatchSet',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/cost-policy-management/high-tax-rate-policy/BatchSet.vue'
      ),
    meta: {
      SecondaryMenu: '政策备案维护', //二级菜单
      title: '批量设置高开税率政策',
      // breadcrumb: [
      //   {
      //     title: '高开税率政策',
      //     name: 'highTaxRatePolicy',
      //   },
      // ],
    },
  },
  // 费控系统 费用政策管理  政策备案维护    高开税率政策
  {
    path: '/costControlSystem/policyFilingMaintenance/highTaxRatePolicy/add/:id/:policyId',
    name: 'AddHighTaxRatePolicy',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/costControlSystem/cost-policy-management/high-tax-rate-policy/Add.vue'
      ),
    meta: {
      SecondaryMenu: '政策备案维护', //二级菜单
      title: '新增政策',
      // breadcrumb: [
      //   {
      //     title: '高开税率政策',
      //     name: 'HighTaxRatePolicy',
      //   },
      // ],
    },
  },
]

export default policyFilingMaintenanceRouter
